<template>
    <dashboard
        simulator-url-name="campos_novos.simulator"
        :sidebar-items="$options.sidebar"
        :loading="loading"
        loading-text="Carregando dados de Campos Novos, aguarde..."
    >
        <keep-alive><router-view /></keep-alive>
    </dashboard>
</template>

<script>
import Dashboard from "@/modules/dashboard/containers/Dashboard";
import sleep from "@/utils/sleep";

export default {
    name: "CamposNovos",
    sidebar: [
        {
            url: "campos_novos.alerts",
            className: "alerts",
            text: "Alertas"
        },
        {
            url: "campos_novos.reservoir",
            className: "reservoir",
            text: "Nível Reservatório"
        },
        {
            url: "campos_novos.prisms",
            className: "prisms",
            text: "Prismas"
        },
        {
            url: "campos_novos.sensors",
            className: "sensors",
            text: "Sensores"
        },
        {
            url: "campos_novos.visualization",
            className: "visualization",
            text: "Visualização"
        }
    ],
    components: {
        Dashboard
    },
    data() {
        return {
            loading: true
        };
    },
    async mounted() {
        if (this.$store.getters["campos_novos/needInitialize"]) {
            await sleep(500);
            await this.$store.dispatch("campos_novos/initialize");

            this.loading = false;
        } else {
            this.loading = false;
        }
    }
};
</script>
